/**
 * Mock SSOT for HotelsRiver hotel-profile + room selection UI demo.
 * Linked from hotels-results-mockup via ?hotelId=
 */

import { MOCK_HOTELS } from "../hotelsResultsMockup/mockHotelsData";
import {
  formatFx,
  formatIls,
} from "../packageProfileMockup/mockPackageProfileData";

export { formatFx, formatIls };

const FX_USD_TO_ILS = 3.089;

const EXTRA_GALLERY = [
  "https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=1200&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=1200&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1200&q=80&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?w=1200&q=80&auto=format&fit=crop",
];

/** Per-hotel room menus (deltas vs base room total in USD). */
const ROOMS_BY_HOTEL = {
  "htl-sun-hall": [
    {
      id: "room-std",
      name: "Superior Sea View",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 0,
      immediateConfirm: true,
      refundable: true,
    },
    {
      id: "room-deluxe",
      name: "Deluxe Sea View",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 85,
      immediateConfirm: true,
      refundable: true,
    },
    {
      id: "room-suite",
      name: "Junior Suite",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 180,
      immediateConfirm: false,
      refundable: false,
    },
  ],
  "htl-radisson": [
    {
      id: "room-dlx",
      name: "Deluxe Room",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 0,
      immediateConfirm: true,
      refundable: false,
    },
    {
      id: "room-premium",
      name: "Premium Sea View",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 120,
      immediateConfirm: true,
      refundable: false,
    },
    {
      id: "room-family",
      name: "Family Room",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים + ילד",
      deltaUsd: 210,
      immediateConfirm: false,
      refundable: false,
    },
  ],
  "htl-senatore": [
    {
      id: "room-double",
      name: "Standard Double",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 0,
      immediateConfirm: true,
      refundable: true,
    },
    {
      id: "room-twin",
      name: "Twin City View",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 45,
      immediateConfirm: true,
      refundable: true,
    },
    {
      id: "room-exec",
      name: "Executive Room",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 110,
      immediateConfirm: true,
      refundable: false,
    },
  ],
  "htl-livadhiotis": [
    {
      id: "room-twin",
      name: "Twin Room",
      boardLabel: "לינה בלבד",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 0,
      immediateConfirm: true,
      refundable: true,
    },
    {
      id: "room-dbl-bb",
      name: "Double + Breakfast",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 55,
      immediateConfirm: true,
      refundable: true,
    },
  ],
  "htl-golden-bay": [
    {
      id: "room-family",
      name: "Family Suite",
      boardLabel: "הכל כלול",
      capacityLabel: "2 מבוגרים + 2 ילדים",
      deltaUsd: 0,
      immediateConfirm: false,
      refundable: false,
    },
    {
      id: "room-sv",
      name: "Sea View Suite",
      boardLabel: "הכל כלול",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 160,
      immediateConfirm: false,
      refundable: false,
    },
  ],
  "htl-castle": [
    {
      id: "room-garden",
      name: "Garden View",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 0,
      immediateConfirm: true,
      refundable: true,
    },
    {
      id: "room-pool",
      name: "Pool View",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 70,
      immediateConfirm: true,
      refundable: true,
    },
    {
      id: "room-spa",
      name: "Spa Suite",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 195,
      immediateConfirm: false,
      refundable: true,
    },
  ],
  "htl-eleonora": [
    {
      id: "room-studio",
      name: "Studio Apartment",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 0,
      immediateConfirm: true,
      refundable: true,
    },
    {
      id: "room-1br",
      name: "1-Bedroom Apartment",
      boardLabel: "ארוחת בוקר",
      capacityLabel: "2 מבוגרים + ילד",
      deltaUsd: 90,
      immediateConfirm: true,
      refundable: true,
    },
  ],
  "htl-saint-raphael": [
    {
      id: "room-sv",
      name: "Sea View Room",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 0,
      immediateConfirm: false,
      refundable: true,
    },
    {
      id: "room-club",
      name: "Club Sea View",
      boardLabel: "חצי פנסיון",
      capacityLabel: "2 מבוגרים",
      deltaUsd: 140,
      immediateConfirm: false,
      refundable: true,
    },
  ],
};

const DEFAULT_ROOMS = [
  {
    id: "room-std",
    name: "Standard Room",
    boardLabel: "ארוחת בוקר",
    capacityLabel: "2 מבוגרים",
    deltaUsd: 0,
    immediateConfirm: true,
    refundable: true,
  },
  {
    id: "room-sup",
    name: "Superior Room",
    boardLabel: "ארוחת בוקר",
    capacityLabel: "2 מבוגרים",
    deltaUsd: 75,
    immediateConfirm: true,
    refundable: true,
  },
];

const DESCRIPTIONS = {
  "htl-sun-hall":
    "מלון על טיילת לרנקה עם נוף לים, בריכה חיצונית וחדרים מעודכנים. מיקום מצוין לטיול רגלי ל־Finikoudes.",
  "htl-radisson":
    "ריזורט חוף 5 כוכבים עם ספא, מסעדות ובריכות. אידיאלי לזוגות ולמשפחות שמחפשות חוויה מלאה על החוף.",
  "htl-senatore":
    "מלון עירוני במרכז לרנקה, קרוב לחנויות ומסעדות. חדרי סטנדרט וחדרי Executive עם נוחות גבוהה.",
  "htl-livadhiotis":
    "מלון עיר קומפקטי ונוח, מתאים לשהייה קצרה במחיר משתלם. קרוב לתחבורה ולמרכז.",
  "htl-golden-bay":
    "ריזורט הכל-כלול עם מתחמי בריכות ואזורי ילדים. מתאים במיוחד למשפחות.",
  "htl-castle":
    "ריזורט וספא ליד החוף, עם גינות, טניס ואפשרויות חצי פנסיון.",
  "htl-eleonora":
    "דירות מלון עם מטבחון, בריכה משותפת ומיקום ליד אזור מקנזי.",
  "htl-saint-raphael":
    "ריזורט יוקרה בלימסול על החוף, עם ספא, גולף ושירות מועדון.",
};

export const HOTEL_PROFILE_STAGES = [
  { id: "results", label: "תוצאות", done: true },
  { id: "profile", label: "מלון וחדרים", active: true },
  { id: "passengers", label: "נוסעים", stub: true },
  { id: "payment", label: "תשלום", stub: true },
];

function buildRooms(hotel) {
  const baseTotal = Number(hotel.priceTotalUsd) || 0;
  const templates = ROOMS_BY_HOTEL[hotel.id] || DEFAULT_ROOMS;
  return templates.map((r) => {
    const roomTotalUsd = baseTotal + (Number(r.deltaUsd) || 0);
    const deltaUsd = Number(r.deltaUsd) || 0;
    return {
      ...r,
      currency: "USD",
      deltaPerPersonFx: deltaUsd / 2,
      deltaPerPersonIls: (deltaUsd / 2) * FX_USD_TO_ILS,
      roomTotalFx: roomTotalUsd,
      roomTotalIls: roomTotalUsd * FX_USD_TO_ILS,
    };
  });
}

/**
 * @param {string|null|undefined} hotelId
 */
export function getHotelProfileById(hotelId) {
  const hotel =
    MOCK_HOTELS.find((h) => h.id === hotelId) ||
    MOCK_HOTELS.find((h) => h.destinationId === "larnaca") ||
    MOCK_HOTELS[0];

  const gallery = [hotel.imageUrl, ...EXTRA_GALLERY.filter((u) => u !== hotel.imageUrl)].slice(
    0,
    5
  );

  return {
    id: hotel.id,
    hotelName: hotel.hotelName,
    stars: hotel.stars,
    city: hotel.city,
    country: hotel.country,
    area: hotel.area,
    address: hotel.area ? `${hotel.area}, ${hotel.city}` : hotel.city,
    boardLabel: hotel.boardLabel,
    nights: hotel.nights,
    roomsCount: hotel.rooms || 1,
    checkInLabel: "15/11/2026",
    checkOutLabel: "19/11/2026",
    dateRangeLabel: hotel.dateRangeLabel,
    currency: "USD",
    baseTotalUsd: hotel.priceTotalUsd,
    agentNetPerPerson: hotel.priceTotalUsd / 2,
    agentNetPerPersonIls: (hotel.priceTotalUsd / 2) * FX_USD_TO_ILS,
    immediateConfirm: hotel.immediateConfirm,
    refundable: hotel.refundable,
    beachfront: hotel.beachfront,
    distanceLabel: hotel.distanceLabel,
    amenities: hotel.amenities || [],
    description: DESCRIPTIONS[hotel.id] || "מלון איכותי ביעד שנבחר.",
    gallery,
    rooms: buildRooms(hotel),
    paxCount: 2,
  };
}

export function formatRoomDelta(room, currency = "USD") {
  const fx = Number(room?.deltaPerPersonFx);
  if (Number.isFinite(fx) && fx > 0) {
    return { label: `+${formatFx(fx, currency)}`, sub: "לאדם מול חדר בסיס" };
  }
  const ils = Number(room?.deltaPerPersonIls);
  if (Number.isFinite(ils) && ils > 0) {
    return { label: `+${formatIls(ils)}`, sub: "לאדם מול חדר בסיס" };
  }
  return null;
}
